var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('fieldset',{staticClass:"language-toggle font-small"},[_c('legend',{staticClass:"hidden-visually"},[_vm._v("Select language")]),_vm._v(" "),_vm._l((_vm.options),function(opt,index){return _c('label',{key:opt.value,class:{
			'language-option': true,
			'ell-rtl': opt.rtl
		}},[_c('input',{staticClass:"hidden-visually",attrs:{"type":"radio","name":"language-toggle"},domProps:{"value":opt.value,"checked":opt.selected},on:{"change":function($event){return _vm.onLanguageClick(opt.value)}}}),_vm._v(" "),_c('span',{staticClass:"option-text",class:{
				'language-selected': opt.selected
			}},[_vm._v(_vm._s(opt.text))]),_vm._v(" "),(index !== _vm.options.length - 1)?_c('span',[_vm._v(" | ")]):_vm._e()])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }